export default function({ state, commit, dispatch }, query) {
  const providerId = query.id;
  const urlQuery = query.next
    ? { next: query.next, limit: 250 }
    : { limit: 250 };
  return dispatch(
    "get",
    {
      url: "/provider/" + query.id + "/patient",
      query: urlQuery,
    },
    {
      root: true,
    }
  )
    .then((response) => {
      commit("createTagToColorMapping", response.patient);

      commit("addProviderPatients", {
        id: query.id,
        patient: response.patient,
      });
      try {
        if (response.profile) {
          const profile = response.profile.reduce(
            (profileAcc, profile) => ({ ...profileAcc, [profile.id]: profile }),
            {}
          );
          if (!query.next) commit("content/cache", { profile }, { root: true });
        }
      } catch (error) {
        console.error("Error commiting profiles to vuex", error);
      }

      commit("addNextPatients", {
        provider: query.id,
        next: response.next ? response.next : true,
      });
      if (query.all && response.next) {
        dispatch("loadProviderPatients", {
          ...query,
          next: response.next,
        });
      }
    })
    .catch((error) => {
      throw error;
    });
}
